import MachineSpeedHourWidgetContainer from "./MachineSpeedHourWidgetContainer";
export type { MachineSpeedHourApiResponse } from "./MachineSpeedHour";

export default MachineSpeedHourWidgetContainer;
